var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "label",
    { staticClass: "portal-search-field" },
    [
      _c("portal-icon", {
        attrs: { name: "search", size: 18, "aria-hidden": "true" }
      }),
      _c("input", {
        attrs: {
          type: "search",
          placeholder: _vm.placeholder,
          "aria-label": _vm.label
        },
        domProps: { value: _vm.value || "" },
        on: {
          input: function($event) {
            return _vm.$emit("input", $event.target.value)
          },
          change: function($event) {
            return _vm.$emit("change", $event.target.value)
          }
        }
      }),
      _vm.value
        ? _c(
            "button",
            {
              staticClass: "clear-search",
              attrs: { type: "button", "aria-label": _vm.clearLabel },
              on: { click: _vm.clear }
            },
            [_c("portal-icon", { attrs: { name: "x", size: 16 } })],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }